import styled from 'styled-components';
import Image from 'next/image';
import PortableText from '@sanity/block-content-to-react';

export const TitleContainer = styled.div`
  background-color: ${($props) => $props.theme.colours.titleBackground};
  border-radius: 0.25rem;
  padding: 0.125rem 0;
  margin: 0 0 1rem 0;
`;

export const QuoteRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const QuoteColumn = styled.div`
  padding: 1rem;
  flex: 1;
  width: 100%;
`;

export const Quote = styled.div`
  background-color: ${(props) => props.theme.colours.lightBrown};
  padding: 1rem;
  filter: drop-shadow(2px 2px 1px rgba(0, 0, 0, 0.125));
  border-radius: 0.25rem;
`;

export const Speech = styled.p`
  background-color: #eaeaea;
  padding: 0.5rem;
  border-radius: 0.25rem;
`;

export const Summary = styled.summary`
  background-color: #ddd2b6;
  padding: 0.5rem;
  border-radius: 0.25rem;
  filter: drop-shadow(2px 2px 1px rgba(0, 0, 0, 0.125));
  margin-bottom: 1rem;
`;

export const Answer = styled.p`
  background-color: #faf1e7;
  padding: 1rem;
`;

export function summary(index: string, question: string, answer: string) {
  return (
    <details id={index} className={`pointer`} key={question}>
      <Summary>{question}</Summary>
      <Answer>{answer}</Answer>
    </details>
  );
}

export function affirmation(title: string, explanation: string) {
  return (
    <article key={title}>
      <Quote>
        <h2>{title}</h2>
        <p>{explanation}</p>
      </Quote>
      <br />
    </article>
  );
}

export const FilterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Filter = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  background-color: #eaeaea;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  margin: 0 0.5rem;
  width: 5rem;
  cursor: pointer;
  :hover {
    font-weight: bolder;
  }
`;

export function hasImage(images: any, num: number, aspect: string) {
  if (images.length !== 0) {
    const url = images[num].imageUrl;
    const alt = images[num].description;
    let height, width;
    if (aspect === 'tall') {
      height = 413;
      width = 275;
    }
    if (aspect === 'long') {
      height = 275;
      width = 413;
    }
    return (
      <Image
        width={width}
        height={height}
        src={url}
        alt={alt}
        layout="responsive"
        style={{ borderRadius: '0.25rem' }}
      />
    );
  }
}

export function hasQuote(quotes: any, num: number) {
  if (quotes.length !== 0 && quotes[num] !== undefined) {
    const quote = quotes[num].content;
    const teacher = quotes[num].teacher.name;
    const book = quotes[num].book.name;
    return (
      <Quote>
        <PortableText blocks={quote}></PortableText>
        <p>
          <strong>{teacher} - </strong>
          <strong>{book}</strong>
        </p>
      </Quote>
    );
  }
}

export const Input = styled.input`
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  background-color: ${($props) => $props.theme.colours.titleBackground};
  border: 1px solid ${($props) => $props.theme.colours.titleBackground};
  border-radius: 0.25rem;
  text-align: center;
  cursor: pointer;
  width: 5rem;
  height: 3rem;
  font-weight: bolder;
  :hover {
    border-color: black;
  }
`;
